import { AppState, Roles, UserAttrs, fetchUser, userSelector } from 'cdx-common';
import React, { createContext, useContext } from 'react';
import { useSelector } from 'react-redux';
import { appStore } from '../store';


export interface SessionInterface {
    user?: UserAttrs,
    isSuperAdmin: boolean,
    isForman: boolean,
    isEmployee: boolean;
}
const SessionContext = createContext({} as unknown as SessionInterface);

export const SessionProvider = (props: { children: React.ReactNode; }) => {

    const userId = useSelector((state: AppState) => state.session.userId);
    const user = useSelector((state: AppState) => userId ? userSelector.selectById(state, userId) : undefined);
    const [isSuperAdmin, setIsSuperAdmin] = React.useState(false);
    const [isForman, setIsFormman] = React.useState(false);
    const [isEmployee, setIsEmployee] = React.useState(false);

    React.useEffect(() => {
        console.log('user and id', user, userId);
        if (userId && userId !== user?.id) {
            appStore.dispatch(fetchUser(userId));
        }
        setIsSuperAdmin(!!user?.roles.find(p => p.role === Roles.SUPERADMIN));
        setIsFormman(!!user?.roles.find(p => p.role === Roles.FOREMAN));
        setIsEmployee(!!user?.roles.find(p => p.role === Roles.EMPLOYEE));
    }, [user, userId]);


    return <SessionContext.Provider value={{
        user,
        isSuperAdmin,
        isForman,
        isEmployee
    }}>{props.children}</SessionContext.Provider>;
};

export const useSession = () => useContext(SessionContext);
